import { default as BSPopover } from 'bootstrap/js/src/popover'

class Popover extends BSPopover {}

export default Popover
